module.exports = "/assets/js/92714a8b4cb9b1f3da6c7866608dd0dd.svg";